// extracted by mini-css-extract-plugin
module.exports = {"item":"Breadcrumbs_item___1mV5","separator":"Breadcrumbs_separator__F_8nD"};